var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-12"},[(_vm.isShowSaleMail && _vm.isEditableSales)?_c('sales-mail',{ref:"salesMail",attrs:{"no":_vm.no,"sales-target-id":_vm.salesTargetId},on:{"reload":_vm.$listeners['reload']}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }